import { useEffect, useContext } from "react";
import dayjs from "dayjs";
import * as RNLocalize from "react-native-localize";
import AppContext from "./context";
import dictionary from "./Dictionary.json";
import "dayjs/locale/en";
import "dayjs/locale/fr";

export default function Localize() {
  const { setDict, setLang } = useContext(AppContext);

  useEffect(() => {
    var parsedUrl = new URL(window.location.href)
    var lang = parsedUrl.searchParams.get('lang');
    RNLocalize.addEventListener("change", () => {
      setLanguage();
    });
    if(lang){
      const locales = RNLocalize.getLocales();
      let dictFound = "en";

      locales.some((l) => {
        if (dictionary[l.languageCode] && l.languageCode == lang) {
          dictFound = l.languageCode;
          return true;
        }
        return false;
      });
      console.log('SET DICT:', dictFound);
      setDict(dictionary[dictFound]);
      setLang(dictFound);
      dayjs.locale(dictFound);
    }else
      setLanguage();
  }, []);

  const setLanguage = () => {
    const locales = RNLocalize.getLocales();
    let dictFound = "en";

    locales.some((l) => {
      if (dictionary[l.languageCode]) {
        dictFound = l.languageCode;
        return true;
      }
      return false;
    });
    //console.log('SET DICT:', dictFound);
    setDict(dictionary[dictFound]);
    setLang(dictFound);
    dayjs.locale(dictFound);
  };
  return null;
}
